import React from "react"
import { ThemeProvider } from "@material-ui/core/styles"

import theme from "../theme"

export default function ThemeWrapper({ children }) {
  return <ThemeProvider theme={theme}>{children}</ThemeProvider>
}
